import React from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { registerUser } from '../../../services/index'
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
 

const SignupSchema = Yup.object().shape({
    username: Yup.string()
     .min(2, 'Too Short!')
     .max(50, 'Too Long!')
     .required('Required'),
    password: Yup.string()
     .min(2, 'Too Short!')
     .max(50, 'Too Long!')
     .required('Required'),
   email: Yup.string().email('Invalid email').required('Required'),
 });

function index() {
    const MySwal = withReactContent(Swal);
    const handleSucces = () => {
        MySwal.fire({
            title: 'Se creo el usuario con exito.',
            icon: 'success',
            width: 600,
            padding: '3em',
            background: 'rgba(225,225,225,0.8)',
        });
    };
    const handleError = (message) => {
        MySwal.fire({
            title: message,
            icon: 'Error',
            width: 600,
            padding: '3em',
            background: 'rgba(225,225,225,0.8)',
        });
    };
    return (
        <div>
            <Formik
                initialValues={{
                    username: '',
                    password: '',
                    email: '',
                    rol: 'admin'
                }}
                validationSchema={SignupSchema}
                onSubmit={async (values, {setSubmitting, resetForm}) => {
                    const res = await registerUser(values)
                    console.log(res);
                    if( res.data.code !== 200){
                        handleError(res.data.message)
                        setSubmitting(false)
                    } else {
                        handleSucces()
                        resetForm({})
                        setSubmitting(false)
                    }
                }}
                >
                {({ isSubmitting, errors, touched, values }) => (
                    <Form>
                        <div className="form-group icon-input mb-1">
                            <i className="font-sm ti-email text-grey-500 pe-0"></i>
                            <Field 
                                type="text" 
                                name="email" 
                                placeholder="Email"  
                                className="style2-input ps-5 form-control text-grey-900 font-xss ls-3"    
                            />
                        </div>                    
                        {errors.email && touched.email ? <div>{errors.email}</div> : null}
                        <div className="form-group icon-input mb-3">
                            <i className="font-sm ti-user text-grey-500 pe-0"></i>
                            <Field 
                                type="text" 
                                name="username" 
                                placeholder="Usuario"
                                className="style2-input ps-5 form-control text-grey-900 font-xsss fw-600"
                            />                     
                        </div>
                        {errors.username && touched.username ? (
                            <div>{errors.username}</div>
                        ) : null}
                        <div className="form-group icon-input mb-1">
                            <Field 
                                type="Password" 
                                name="password" 
                                placeholder="Contraseña"  
                                className="style2-input ps-5 form-control text-grey-900 font-xss ls-3"    
                            />
                            <i className="font-sm ti-lock text-grey-500 pe-0"></i>
                        </div>                    
                        {errors.password && touched.password ? (
                            <div>{errors.password}</div>
                        ) : null}
                    <div className="form-check text-left mb-3">
                        <Field type="checkbox" name="toggle" className="form-check-input mt-2"/>
                        <label className="form-check-label font-xsss text-grey-500">Recuerdame</label>
                        <a href="/forgot" className="fw-600 font-xsss text-grey-700 mt-1 float-right">Olvidaste tu contraseña?</a>
                    </div>
                    <div className="col-sm-12 p-0 text-left">
                        <div className="form-group mb-1"><button type="submit" disabled={isSubmitting} className="form-control text-center style2-input text-white fw-600 bg-dark border-0 p-0 ">{isSubmitting ? 'Registrarme' : 'Cargando...'}</button></div>
                        <h6 className="text-grey-500 font-xsss fw-500 mt-0 mb-0 lh-32">Ya tienes cuenta <a href="/login" className="fw-700 ms-1">Login</a></h6>
                    </div>
                    </Form>
                )}
                </Formik>
        </div>
    )
}

export default index
